import { useMemo } from 'react';

// Returns null when the editor is empty AND when the JSON is invalid.
// Callers treat "no parsed event available" uniformly in both cases — the
// editor surfaces the invalid-JSON state to the user separately.
export default function useParsedInput(input) {
  const parsedInput = useMemo(() => {
    if (!input) return null;
    try {
      return JSON.parse(input);
    } catch {
      return null;
    }
  }, [input]);

  return { parsedInput };
}
